import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";

@Component({
  selector: "app-ub-conv-fee-tpm",
  templateUrl: "./ub-conv-fee-tpm.component.html"
})
export class UBCONVFEETPMComponent implements OnInit {
  actionmode: string = "Search";
  showList: boolean = false;
  searchlist: boolean = true;
  screentitle: string = "Convienience Fee Tpm Master";
  search_details: any = [];
  screen_details: any = [];
  EditData: any = [];
  filters = ["TPM_ID"];
  childtables = ["UB_CONV_FEE_TPM_LIST"];
  serachtabledata:any=[];
  editFlag: any = false;
  searchresult = false;
  loader: any = false;
  viewpage = false;
  parent_table = "UB_CONV_FEE_TPM";
  constructor(private vernostService: VernostServiceService) {}

  ngOnInit() {}

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
  }

  searchForm() {
    this.search_details = [];
    this.screen_details = [];
    this.serachtabledata = [];
    this.editFlag = false;
    document.getElementById("errs").innerHTML = ""
    this.viewpage = false;
    this.searchresult = false;
    this.actionmode = "Search";
  }
  searchData() {

    this.searchlist = false;
    this.loader = true;

   

    var field1 = this.search_details.TPM_JOURNEY_TYPE;
    var field2 = this.search_details.TPM_START_RANGE;
    var field3 = this.search_details.TPM_END_RANGE;
    var field4 = this.search_details.TPM_CABIN_CLASS;
    var field5 = this.search_details.TPM_START_TIME;
    var field6 = this.search_details.TPM_END_TIME;
    var field7 = this.search_details.CONVIENIENCE_FEE;
    if ((field1 == "" || field1 == undefined) &&
      (field2 == "" || field2 == undefined) &&
      (field3 == "" || field3 == undefined) &&
      (field4 == "" || field4 == undefined) &&
      (field5 == "" || field5 == undefined) &&
      (field6 == "" || field6 == undefined) &&
      (field7 == "" || field7 == undefined)) {
      this.loader = false;
      document.getElementById("errs").innerHTML = "Please apply filter to search";
      this.searchresult = false;
    } 
    else {
      if(field1 != undefined &&
         field1.trim() != "") {
        var fields1 = field1.toUpperCase();
      }

      if(field2 != undefined && 
        field2.trim() != "") {
        var fields2 = field2.toUpperCase();
      }

      var searchitem = [];
      var searchColumn = [];

      if(field1 != "" && 
      field1 != undefined) {
        searchitem.push(fields1);
        searchColumn.push("TPM_JOURNEY_TYPE");
      }

      if(field2 != "" && 
      field2 != undefined) {
        searchitem.push(fields2);
        searchColumn.push("TPM_START_RANGE");
      }

      if(field3 != "" && 
      field3 != undefined) {
        searchitem.push(field3);
        searchColumn.push("TPM_END_RANGE");
      }

      if(field4 != "" && 
      field4 != undefined) {
        searchitem.push(field4);
        searchColumn.push("TPM_CABIN_CLASS");
      }

      if(field5 != "" && 
      field5 != undefined) {
        searchitem.push(field5);
        searchColumn.push("TPM_START_TIME");
      }

      if(field6 != "" && 
      field6 != undefined) {
        searchitem.push(field6);
        searchColumn.push("TPM_END_TIME");
      }

      if(field7 != "" && 
      field7 != undefined) {
        searchitem.push(field7);
        searchColumn.push("CONVIENIENCE_FEE");
      }

      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      // alert(JSON.stringify(Data));
      this.vernostService.searchRecord(Data).subscribe(response => {
        this.loader = false;
        console.log("Searchresponse", response);
        this.serachtabledata = response;
        if (response.length > 0) {
          this.searchresult = true;
          this.serachtabledata = response;
          document.getElementById("errs").innerHTML = "";
         console.log("serachtabledata=",this.serachtabledata);
          // this.logService.create_log_masters(
          //   "'Component Name':Airline Master,'Action':Srarch Record,'Modified by':" +
          //     localStorage.getItem("fname"),
          //   "info"
          // );
        } else {
          this.searchresult = false;
          document.getElementById("errs").innerHTML = "Record not found";
        }
      });
    }
  }
  
   submitData1() {
    console.log("this.screen_details", this.screen_details);
    let id;
  if(this.EditData.length>0){
  id=this.EditData[0]["TPM_ID"]
  }
    var TPMArray = {
       ID: id,
      // ID:this.EditData[0]["TPM_ID"],
      JourneyType: this.screen_details.TPM_JOURNEY_TYPE,
      StartRange: this.screen_details.TPM_START_RANGE,
      EndRange: this.screen_details.TPM_END_RANGE,
      CabinClass:this.screen_details.TPM_CABIN_CLASS,
      StartTime:this.screen_details.TPM_START_TIME,
      EndTime:this.screen_details.TPM_END_TIME,
      ConvienienceFee:this.screen_details.CONVIENIENCE_FEE
    };
    if (this.editFlag == false) {
      this.vernostService.InsertTpmFee(TPMArray).subscribe(response => {
        console.log("TPMFeeResponse:-", response);
        if (response != undefined) {
          document.getElementById("errs").innerHTML = "Record Inserted Successfully"
          this.screen_details = [];
        } else {
          document.getElementById("errs").innerHTML = "Record Not Inserted Successfully"
        }

      });
    }
    if (this.editFlag == true) {
      
      //console.log("EditData="+this.EditData[0]["tpm_master_id"]);
      console.log("this.EditData="+JSON.stringify(this.EditData));
      
      this.vernostService.UpdateTpmFee(TPMArray).subscribe(response => {
        console.log("TPMFeeUpdateResponse:-", response);
        if (response != undefined) {
          document.getElementById("errs").innerHTML = "Record Updated Successfully"
          this.screen_details = [];
        } else {
          document.getElementById("errs").innerHTML = "Record Not Updated Successfully"
        }

      });
    }

  }
  showFormData(data, flag) {
    this.EditData = []; 
    console.log("datttttt", data);
    this.EditData.push(data);
    console.log("dattttttfffff", this.EditData);

    if (flag == 1) {
      this.editFlag = false;
      //  alert("viwe data"+this.editFlag);
      this.actionmode = "view";
      this.viewpage = true;


    } else {
      this.editFlag = true;
      // alert("viwe data"+this.editFlag);
      this.actionmode = "Edit";
      this.screen_details.TPM_JOURNEY_TYPE =  this.EditData[0].TPM_JOURNEY_TYPE;
      this.screen_details.TPM_START_RANGE = this.EditData[0].TPM_START_RANGE;
      this.screen_details.TPM_END_RANGE =  this.EditData[0].TPM_END_RANGE;
      this.screen_details.TPM_CABIN_CLASS = this.EditData[0].TPM_CABIN_CLASS;
      this.screen_details.TPM_START_TIME = this.EditData[0].TPM_START_TIME;
      this.screen_details.TPM_END_TIME = this.EditData[0].TPM_END_TIME;
      this.screen_details.CONVIENIENCE_FEE = this.EditData[0].CONVIENIENCE_FEE;
      // console.log("aa",data.origin);
      // console.log("bb",this.screen_details.Destination_Code);
      // console.log("cc",this.screen_details.TPM_Value);
    }

  }
  
}
